"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: "\u03B1\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1, {Retry}.",
  // SLOW_CONNECTION_NOTIFICATION: '',
  Chat: 'Συνομιλία',
  // 'Download file': '',
  // 'Microphone off': '',
  // 'Microphone on': '',
  'Listening…': 'Ακούγοντας…',
  Retry: 'δοκιμή',
  Send: 'Αποστολή',
  Sending: 'αποστολή',
  // 'Speak': '',
  // 'Starting…': '',
  Tax: 'ΦΠΑ',
  Total: 'Σύνολο',
  'Type your message': 'Πληκτρολόγηση μηνύματος',
  // 'Upload file': '',
  VAT: 'VAT' // 'X minutes ago':

};
exports.default = _default;